import React from 'react';
import { useCallback } from 'react';
import { api_getEntities } from '../api/Api';

export function ContactsDave(props) {
 
	const pageSize = 10

	const [page, setPage] = React.useState(0);

	const [entities, setEntities] = React.useState([]);

	const [entityTable, setEntityTable] = React.useState();

	/*
	 * Had to add getContacts as dependency to react useEffect because of warning...
	 * React Hook React.useEffect has a missing dependency: 'getContacts'. Either include it or remove the dependency array  react-hooks/exhaustive-deps
	 * Then had to wrap getContacts in a callback because of...
	 * The 'getContacts' function makes the dependencies of useEffect Hook (at line 21) change on every render. Move it inside the useEffect callback. Alternatively, wrap the definition of 'getContacts' in its own useCallback() Hook  react-hooks/exhaustive-deps
	 * Had to add dependencies to getContacts dependency list because of next warning.
	 */
	const getContacts = useCallback(() => {
		api_getEntities(props.setFormStatus, setEntities, "dkcontacts", page, pageSize)
	}, [page, props.setFormStatus]);

	React.useEffect(() => {
		getContacts()
	}, [page, getContacts]);

	React.useEffect(() => {
		var entityRender = "";

		if (entities != null) {
			if (entities !== undefined && entities.content !== undefined && entities.content.length === 0) {
				entityRender = (
					<div className="entity-table-wide">
						<br />
						You don't currently have any contact messages.
						<br />
					</div>
				)
			} else {
				entityRender = entities.content && entities.content.map(message => (
					<>
						<div>{message.receive_date}</div>
						<div>{message.email}</div>
						<div>{message.name}</div>
						<div>{message.subject}</div>
						<div>{message.message}</div>
					</>
				))
			}
		}
		setEntityTable(entityRender)

	}, [entities]);

	function prevPage() {
		setPage(page - 1);

	}

	function nextPage() {
		setPage(page + 1);
	}

	function getPaginationSection() {
		if (entities !== undefined) {
			return (
				<div className="entity-table-pagination">
					<p>{page === 0 ? "" : <button onClick={() => prevPage()}>Prev</button>}</p>
					<p>Page : {(page + 1)} of {Math.max(1, entities.totalPages)}</p>
					<p>{entities.last ? "" : <button onClick={() => nextPage()}>Next</button>}</p>
				</div>
			)
		} else {
			return ("")
		}
	}


	return (
		<div className="read-panel">
			<h1>Messages</h1>
			<div className="entity-table">
				<div><h3>receive_date</h3></div>
				<div><h3>Email</h3></div>
				<div><h3>Name</h3></div>
				<div><h3>Subject</h3></div>
				<div><h3>Message</h3></div>
				{entityTable}
			</div>
			{getPaginationSection()}
		</div>
	);


}
